import {createContext} from 'react'

const CreateDispatchContext = createContext("");
export {CreateDispatchContext}